import React, { useState, useEffect, useRef } from "react";
import { Fragment } from "react";

import { Button, Form, Row, Col } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import { daysFactor } from "./globalVariables";

function ProjektstatusFreigabe({
   kacheln,
   heading,
   userObjects,
   abschnittsarray,
   shownKachelstatus,
   color,
   showStatusStufen,
}) {
   const [show, setShow] = useState(false);
   const [sortedItems, setSortedItems] = useState([]);
   const [maxCounter, setMaxCounter] = useState(1);

   useEffect(() => {
      //{benutzer: bkad, ids: []}
      if (abschnittsarray) {
         let clonedata = structuredClone(abschnittsarray);
         let personcounter = {};
         let personmaxdatum = {};

         clonedata.forEach((item) => {
            Object.keys(item.kachelstatus).forEach((keyitem) => {
               if (item.kachelstatus[keyitem] != shownKachelstatus) {
                  delete item.kachelstatus[keyitem];
               } else if (item.pmfreigabe[keyitem]) {
                  if (personmaxdatum[item.benutzer]) {
                     if (personmaxdatum[item.benutzer] > new Date(item.pmfreigabe[keyitem])) {
                        personmaxdatum[item.benutzer] = new Date(item.pmfreigabe[keyitem]);
                     }
                  } else {
                     personmaxdatum[item.benutzer] = new Date(item.pmfreigabe[keyitem]);
                  }
               }
            });

            if (Object.keys(item.kachelstatus).length) {
               if (personcounter[item.benutzer] != undefined) {
                  personcounter[item.benutzer].arr.push(item);
                  personcounter[item.benutzer].datum = personmaxdatum[item.benutzer]
                     ? personmaxdatum[item.benutzer]
                     : "";
                  personcounter[item.benutzer].count += Object.keys(item.kachelstatus).length;
               } else {
                  personcounter[item.benutzer] = {
                     arr: [item],
                     datum: personmaxdatum[item.benutzer] ? personmaxdatum[item.benutzer] : "",
                     count: Object.keys(item.kachelstatus).length,
                     benutzerId: item.benutzer,
                  };
               }
            }
         });

         const sortedpersoncounter = Object.values(personcounter).sort((a, b) => {
            if (a.count < b.count) return 1;
            if (a.count > b.count) return -1;

            return 0;
         });

         if (sortedpersoncounter.length) {
            setMaxCounter(sortedpersoncounter[0].count);
            setSortedItems(sortedpersoncounter);
         }
      }
   }, [abschnittsarray]);

   return (
      <div className="projektstatus-l2">
         {heading && <h2>{heading}</h2>}
         {sortedItems.map((item) => {
            let maxDays = item.datum ? Math.round((new Date() - item.datum) / daysFactor) : 10;
            return (
               <React.Fragment key={"_" + item.benutzerId}>
                  <div
                     className={
                        "projektstatus-summe" +
                        (userObjects && userObjects[item.benutzerId] ? "" : " pulsing-background")
                     }
                     style={{
                        backgroundColor: color
                           ? `color-mix(in srgb, ${color} ${(100 * item.count) / maxCounter}%, transparent)`
                           : "rgba(200,150,0," + item.count / maxCounter + ")",
                        color: "white",
                     }}
                     onClick={() => setShow(item.benutzerId)}
                  >
                     {userObjects && userObjects[item.benutzerId] ? (
                        <span>
                           {userObjects[item.benutzerId].Vorname + " " + userObjects[item.benutzerId].Nachname}
                        </span>
                     ) : (
                        <span>
                           <strong>OHNE BETREUER</strong>
                        </span>
                     )}
                     <span className="ms-2">
                        {item.datum && (
                           <small
                              style={{
                                 // backgroundColor: "#fff",
                                 backgroundColor: `color-mix(in srgb, #f00 ${Math.min((100 * maxDays) / 6, 100)}%, #fff3)`,
                                 color: "#fff",
                                 padding: "2px 8px",
                                 borderRadius: "6px",
                                 marginRight: "8px",
                              }}
                           >
                              {maxDays}
                           </small>
                        )}{" "}
                        {item.count} | <small>{item.arr.length}</small>
                     </span>
                  </div>
                  <Modal show={show === item.benutzerId} size="xl" onHide={() => setShow(false)}>
                     <Modal.Header closeButton>
                        <Modal.Title>
                           <div className="projekt-statusheading">
                              {userObjects && userObjects[item.benutzerId] ? (
                                 <span>
                                    {userObjects[item.benutzerId].Vorname + " " + userObjects[item.benutzerId].Nachname}
                                 </span>
                              ) : (
                                 <span>
                                    <strong>OHNE BETREUER</strong>
                                 </span>
                              )}
                              <span className="ms-2">{item.arr.length}</span>
                           </div>
                        </Modal.Title>
                     </Modal.Header>
                     <Modal.Body>
                        <div className="projektstatus-table">
                           {item.arr.map((immo, index) => {
                              // console.log(immo);

                              return (
                                 <React.Fragment key={"k_" + immo.objektnr_extern}>
                                    <h4 className={index != 0 ? "mt-4" : ""}>
                                       {immo.objektbezeichnung
                                          ? immo.objektbezeichnung
                                          : "Objekt " + immo.objektnr_extern}
                                    </h4>
                                    {Object.keys(immo.kachelstatus).map((esk_key) => {
                                       if (kacheln[esk_key]) {
                                          let ablauftage = Math.round(
                                             (new Date() - new Date(immo.pmfreigabe[esk_key])) / daysFactor,
                                          );
                                          return (
                                             <a
                                                style={{
                                                   backgroundColor: color
                                                      ? `color-mix(in srgb, ${color} 80%, #000)`
                                                      : "#000",
                                                }}
                                                key={"akey_" + immo.objektnr_extern + "_" + esk_key}
                                                target="_blank"
                                                href={
                                                   "/datenblatt?estateid=" +
                                                   immo.id +
                                                   "&stufe=" +
                                                   kacheln[esk_key].stufenId +
                                                   "&kachel=" +
                                                   kacheln[esk_key].kachelId
                                                }
                                             >
                                                {kacheln[esk_key].heading}{" "}
                                                {immo.pmfreigabe[esk_key] && (
                                                   <small
                                                      title={new Date(immo.pmfreigabe[esk_key]).toLocaleDateString()}
                                                      style={{
                                                         marginLeft: "14px",
                                                         backgroundColor: `color-mix(in srgb, #f00 ${Math.min((100 * ablauftage) / 6, 100)}%, #0009)`,
                                                         padding: "2px 10px",
                                                         borderRadius: "8px",
                                                         position: "absolute",
                                                         right: "20px",
                                                      }}
                                                   >
                                                      {" "}
                                                      seit{" "}
                                                      {ablauftage != 1 ? ablauftage + " Tagen" : ablauftage + " Tag"}
                                                   </small>
                                                )}
                                             </a>
                                          );
                                       }
                                    })}
                                 </React.Fragment>
                              );
                           })}
                        </div>
                     </Modal.Body>
                     <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShow(false)}>
                           Schliessen
                        </Button>
                     </Modal.Footer>
                  </Modal>
               </React.Fragment>
            );
         })}
      </div>
   );
}
export default ProjektstatusFreigabe;
